import { SET_SESSION_CODE, RESET_SESSION_CODE } from "../utils/constants";

const initialState = {
  sessionCode: "",
};

const sessionCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_CODE:
      return {
        ...state,
        sessionCode: action.payload || null,
      };
    case RESET_SESSION_CODE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default sessionCodeReducer;
